import React from 'react';
import Grid from '@material-ui/core/Grid';
import TextField from '@material-ui/core/TextField';
import { InputAdornment, Theme } from '@material-ui/core';
import createStyles from '@material-ui/core/styles/createStyles';
import withStyles from '@material-ui/core/styles/withStyles';
import Button from '@material-ui/core/Button';

import ApiManager from 'hcla-web-frontend-primitives/app/Api/ApiManager';

import PartsPickerDialog from '../../../../Generic/Parts/PartsPickerDialog';
import { PartsDataJSON } from '../../../../Generic/Parts/ComponentsReactTable';
import Expression from '../../../../../mxGraph/HCLTreeNode/HCLTreeVertexValue/Expression';
import ProxyTypes from '../../../../../mxGraph/HCLTreeNode/HCLTreeVertexValue/ProxyTypes';

import InputRules from './InputRules';

const styles = (theme: Theme) => createStyles({
});

interface Props {
  expression: Expression;
  onChange: (e: React.SyntheticEvent<{}, Event>, error?: boolean, multiple?: boolean) => void;
  classes: any;
}

interface State {
  isDialogOpen: boolean;
  fit: number;
}

class PartsInput extends React.Component<Props, State> {
  constructor(props: Props) {
    super(props);
    this.state = {
      isDialogOpen: false,
      fit: null,
    };
  }

  private toggleDialogOpen = () => {
    this.setState(prevState => ({ isDialogOpen: !prevState.isDialogOpen }));
  };

  handleSet = (e: React.SyntheticEvent<{}, Event>, part: PartsDataJSON) => {
    const { onChange } = this.props;
    e.persist();
    // @ts-ignore
    e.target.value = { part_id: part.id, part_fit: part.failure_data.MTBF_FIT_data.fit, _proxy: ProxyTypes.PARTS_FIT_EXPRESSION };
    this.setState({ fit: part.failure_data.MTBF_FIT_data.fit }, () => {
      // @ts-ignore
      onChange(e, !this.allInputsValid(), true);
    });
  };

  private allInputsValid = () => {
    const { expression } = this.props;
    const { fit } = this.state;
    const isTimeIntervalValid = (InputRules.isTestIntervalValid(expression.getPartsFITTestInterval()));
    // @ts-ignore
    const isFitValid = (InputRules.isNotNegative(fit));
    const isPartValid = expression.getPartId() !== null;
    return (isTimeIntervalValid && isPartValid && isFitValid);
  };

  private handleTimeChange = (e: React.ChangeEvent<HTMLInputElement | HTMLSelectElement | HTMLTextAreaElement>) => {
    const { onChange } = this.props;
    onChange(e, !this.allInputsValid(), false);
  };

  componentDidMount(): void {
    const { expression } = this.props;
    if (expression.getPartId() !== undefined) {
      // @ts-ignore
      ApiManager.getComponent(`/model/?id=${expression.getPartId()}`)
        .then((response: any) => response.json())
      // @ts-ignore
        .then((data: PartsDataJSON) => this.setState({ fit: data[0].failure_data.MTBF_FIT_data.fit }));
    }
  }

  render() {
    const { expression } = this.props;
    const { isDialogOpen, fit } = this.state;

    const isTimeIntervalValid = (InputRules.isTestIntervalValid(expression.getPartsFITTestInterval()));
    // @ts-ignore
    const isFitValid = (InputRules.isNotNegative(fit));
    const isPartValid = expression.getPartId() !== null;
    return (
      <React.Fragment>
        <Grid item xs={12} sm={4}>
          <TextField
            label="Time"
            InputProps={{
              startAdornment: <InputAdornment position="start">t</InputAdornment>,
            }}
            name="parts_fit_test_interval"
            value={expression.getPartsFITTestInterval()}
            error={!isTimeIntervalValid}
            margin="normal"
            type="number"
            onChange={this.handleTimeChange}
            fullWidth
            required
            variant="outlined"
            helperText={isTimeIntervalValid ? undefined : InputRules.DESCRIPTIONS.TEST_INTERVAL}
          />
          <Grid
            container
            direction="row"
            spacing={8}
          >
            <Grid item xs={12} sm={6}>
              <TextField
                label="Part ID"
                name="part_id"
                value={expression.getPartId()}
                margin="normal"
                type="number"
                fullWidth
                error={!isPartValid}
                helperText={isPartValid ? undefined : InputRules.DESCRIPTIONS.PART_ID}
                variant="outlined"
                InputLabelProps={{ shrink: true }}
                disabled
              />
            </Grid>
            <Grid item xs={12} sm={6}>
              <TextField
                label="FIT"
                name="part_fit"
                value={fit}
                defaultValue={fit}
                error={!isFitValid}
                margin="normal"
                type="number"
                fullWidth
                variant="outlined"
                disabled
                InputLabelProps={{ shrink: true }}
                helperText={isFitValid ? undefined : InputRules.DESCRIPTIONS.FAILURE_RATE}
              />
            </Grid>
          </Grid>
          <Grid item xs={12}>
            <Button
              fullWidth
              variant="outlined"
              size="large"
              onClick={this.toggleDialogOpen}
              color="secondary"
            >
              Select
            </Button>
          </Grid>
        </Grid>
        <PartsPickerDialog
          open={isDialogOpen}
          toggleDialog={this.toggleDialogOpen}
          doSet={this.handleSet}
        />
      </React.Fragment>
    );
  }
}

export default withStyles(styles)(PartsInput);
